const kindOfSticky =(id)=>{
    const identity = "Element Position Setter";// EPOS :)
    const elemID = id;
    //csak akkor fut ha letezik az elem
    if ( !document.getElementById(elemID) ) { return; }

    // calculates the elemement's botom distance from document top (if elem pos is static)//
    //works only with position fixed or static element //TODO any kind of pos.
    const getBottom=(elemID)=> {

        let elem = document.getElementById(elemID); 

        //save element's position and set position to static
        let savedPosition = '';
        elem.style.position == 'static' ? savedPosition ='static' : savedPosition = 'fixed';
        elem.style.position = 'static';

        //get element's bottom distance from document top
        let elemRect = elem.getBoundingClientRect();
        let bottom = elemRect.bottom + window.scrollY;//+1 for safari fix (?)

        //restore element's initial position
        elem.style.position = savedPosition;

        return bottom;

    }

    const setPosition=(elemID)=> {

        let elem = document.getElementById(elemID); 
        let elemHeight = elem.offsetHeight + parseInt(window.getComputedStyle(elem).marginTop, 10);//elem height + elem's top-margin
        let viewportHeight = document.documentElement.clientHeight;
        let elemBottom = getBottom(elemID);

        if (elemBottom - window.scrollY >= viewportHeight) {
            //ha az elem kilog alul a viowporbol akkor lehessen meg scrollozni
            elem.style.position = "static";
        } else {
            // ha nem akkor fixen ragad a kepre
            elem.style.position = "fixed";

            // ha kissebb mint a viewport akkor ugy van a top hogy a teteje "tapadjon",
            // ha nagyobb akkor a teteje kilog, az alja meg a viewport aljaig er
            elem.style.top = Math.max(0,elemHeight - viewportHeight)*-1 + "px";
        }
    }

    setPosition(elemID);
}